module.exports = __webpack_public_path__ + "static/img/company_history1975.51a78731.jpg";